import React from "react";
const Slider = ({ min, max, step, value, onChange, className = "" }) => {
    return (React.createElement("div", { className: className },
        React.createElement("input", { type: "range", min: min, max: max, step: step, value: value, className: "slider", onChange: onChange })));
};
export { Slider };
